import axios from 'axios';
import { getConfig } from '../data/config';

let isWidgetMode = false;
let authUrlValue = '';

export function setWidgetMode(widgetMode: boolean) {
  isWidgetMode = widgetMode;
}

export function setAuthUrl(url: string) {
  authUrlValue = url;
}

export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(config => {
  config.headers = config.headers || {};

  if (isWidgetMode && authUrlValue) {
    config.baseURL = authUrlValue;
  }

  if (getConfig()) {
    const webConfig = getConfig();
    config.headers['msg-ctx-env'] = webConfig.CtxEnv;
    config.headers['msg-ctx-src'] = webConfig.CtxSrc;
    config.headers['msg-ctx-src-module'] = 'web'; // hardcode: web
    config.headers['msg-ctx-user-id'] = crypto.randomUUID();
  }
  config.headers['msg-ctx-id'] = crypto.randomUUID();
  if (!config.headers['msg-ctx-corr-id']) {
    config.headers['msg-ctx-corr-id'] = crypto.randomUUID();
  }
  return config;
});
